import React, { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import Layout from "../Layout/Layout";
import DynamicPageRenderer from "../pageInside/exeemple_page/DynamicPageRenderer";
import useDataLoader from "../pageInside/exeemple_page/DataLoader";

const PAGE_ID = "INVESTMENTS_HOME";

const Investments = ({ infoSource, laguangeElakay, homeStyles, nbrArr }) => {
  const location = useLocation();
  const limit = 12;
  const lastLoadSignatureRef = useRef(null);

  const queryState = useMemo(() => {
    const query = new URLSearchParams(location.search);
    return {
      skip: Math.max(parseInt(query.get("skip"), 10) || 0, 0),
      filters: {
        q: query.get("q") || "",
        category: query.get("category") || "",
        subCategory: query.get("subCategory") || "",
        projectType: query.get("projectType") || "",
        projectMode: query.get("projectMode") || "",
        revenueType: query.get("revenueType") || "",
        featured: query.get("featured") || "",
        tag: query.get("tag") || "",
        sortBy: query.get("sortBy") || "createdAt",
        order: query.get("order") || "desc",
      },
    };
  }, [location.search]);

  const {
    pageData,
    loading,
    loadPageData,
    reloadFacets,
  } = useDataLoader({
    pageId: PAGE_ID,
    infoSource,
    token: infoSource?.token,
    skip: queryState.skip,
    limit,
    investmentFilters: queryState.filters,
  });

  const loadSignature = useMemo(
    () =>
      JSON.stringify({
        skip: queryState.skip,
        limit,
        filters: queryState.filters,
      }),
    [limit, queryState.filters, queryState.skip]
  );

  useEffect(() => {
    if (lastLoadSignatureRef.current === loadSignature) return;
    lastLoadSignatureRef.current = loadSignature;
    loadPageData({ force: true });
  }, [loadPageData, loadSignature]);

  return (
    <Layout
      infoSource={infoSource}
      loading={loading && !pageData?.investmentCatalog}
      SliderPunShow={false}
      outOffPage={false}
      showFilterMenu={false}
      enableBodyParticles={false}
      enableFloatingSquares={false}
    >
      <div style={{ ...infoSource?.styleNav, paddingTop: 90 }}>
        <DynamicPageRenderer
          pageId={PAGE_ID}
          pageData={pageData}
          infoSource={infoSource}
          laguangeElakay={laguangeElakay}
          homeStyles={homeStyles}
          nbrArr={nbrArr}
          reloadFacets={reloadFacets}
        />
      </div>
    </Layout>
  );
};

export default Investments;
